import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import styled from 'styled-components';

const Navbar2 = () => {

  const handleNavLinkClick = () => {
    const navbarToggler = document.querySelector('.navbar-toggler');
    const navbarCollapse = document.querySelector('.navbar-collapse');
    if (navbarToggler && navbarCollapse.classList.contains('show')) {
      navbarToggler.click();
    }
  };

  return (
    <Navbar>
      <nav className="navbar navbar-expand-lg fixed-top navbar-light bg-light">
        <div className="container text-black navbar-text fs-5">
          <img src={`${process.env.PUBLIC_URL}/mshineLogo.png`} className="hero-img" alt="MShine Lubricants" />
          <div className="navbar-brand mx-2">PURE SURETY AND QUALITY</div>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation"> 
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse justify-content-end" id="navbarNavAltMarkup">
            <div className="navbar-nav">
              <ScrollLink className="nav-link" to="home" spy={true} smooth={true} offset={-70} duration={100} onClick={handleNavLinkClick}>HOME</ScrollLink>
              <ScrollLink className="nav-link" to="product" spy={true} smooth={true} offset={-70} duration={100} onClick={handleNavLinkClick}>PRODUCTS</ScrollLink>
              <ScrollLink className="nav-link" to="about" spy={true} smooth={true} offset={-70} duration={100} onClick={handleNavLinkClick}>ABOUT US</ScrollLink>
              <ScrollLink className="nav-link" to="dealership" spy={true} smooth={true} offset={-70} duration={100} onClick={handleNavLinkClick}>DEALERSHIP</ScrollLink>
              <ScrollLink className="nav-link" to="contact" spy={true} smooth={true} offset={-70} duration={100} onClick={handleNavLinkClick}>CONTACT US</ScrollLink>
            </div>
          </div>
        </div>
      </nav>
    </Navbar>
  );
}

const Navbar = styled.nav`


.navbar-nav{
  gap: 15px;
}
  .hero-img {
    width: 150px;
    height: 40px;
  }

  .navbar-brand {
    color: #2920d4;
    font-size: 1rem; /* Adjust the font size for the navbar brand */
  }

  .nav-link {
    cursor: pointer;
    color: black;
    transition: background-color 0.3s ease;
    font-style: normal;
    font-size: 1rem; /* Adjust the font size for the nav links */
    padding: 8px 18px !important; /* Adjust the padding for the nav links */
    text-decoration: none;
    /* border: 1px solid black; */
  }

  .nav-link:hover {
    background-color:  #2363e7;
    color: white;
    
    /* font-size:1rem; */
    font-weight: 500;
  }

  .navbar-toggler {
    border: none;
  }

  .navbar-toggler-icon {
    filter: invert(29%) sepia(83%) saturate(2881%) hue-rotate(214deg) brightness(89%) contrast(98%);
  }

  @media (max-width: 768px) {
    .navbar {
      padding: 10px 15px;
    }

    .nav-link {
      font-size: 0.875rem; /* Reduce the font size for smaller screens */
      padding: 5px 8px; /* Adjust the padding for smaller screens */
    }

    .hero-img {
      width: 120px; /* Reduce the logo size for smaller screens */
      height: 32px;
    }

    .navbar-brand {
      font-size: 0.875rem; /* Reduce the font size for the navbar brand on smaller screens */
    }
  }

  @media (max-width: 480px) {
    .navbar {
      padding: 10px 15px;
    }

    .nav-link {
      font-size: 0.75rem; /* Further reduce the font size for very small screens */
      padding: 5px 6px; /* Further adjust the padding for very small screens */
    }

    .hero-img {
      width: 100px; /* Further reduce the logo size for very small screens */
      height: 27px;
    }

    .navbar-brand {
      font-size: 0.75rem; /* Further reduce the font size for the navbar brand on very small screens */
    }

    .nav-link:hover {
    background-color: yellow;
    font-size:1.1rem
  }
  }
`;

export default Navbar2;





